'use strict';
const queryStringToMap = require('./query-string-to-map'),
	unixTimestamp = require('@mindmup/js-utils/src/unix-timestamp'),
	BUFFER = 5 * 60,
	parsableDateString = (urlDateTimeString) => {
		const [urlDateString, urlTimeString] = urlDateTimeString.split('T'),
			dateComponents = [
				urlDateString.slice(0, 4),
				urlDateString.slice(4, 6),
				urlDateString.slice(6),
			],
			timeComponents = [
				urlTimeString.slice(0, 2),
				urlTimeString.slice(2, 4),
				urlTimeString.slice(4),
			];
		return `${dateComponents.join('-')}T${timeComponents.join(':')}`;
	},
	unixTimeTomAmzDateString = (urlDateTimeString) => {
		const parsableDate = parsableDateString(urlDateTimeString);
		return Math.floor(Date.parse(parsableDate) / 1000);
	};

module.exports = function s3SignatureValid(signedUrl) {
	if (!signedUrl) {
		return false;
	}
	const qMark = signedUrl.indexOf('?'),
		qString = (qMark >= 0) && signedUrl.substr(qMark),
		params = qString && queryStringToMap(qString),
		urlDateTimeString = params['X-Amz-Date'],
		urlTimestamp = urlDateTimeString && unixTimeTomAmzDateString(urlDateTimeString),
		urlExpiresString = params['X-Amz-Expires'],
		urlExpires = urlExpiresString && parseInt(urlExpiresString);

	if (!params || !urlExpires || !urlTimestamp) {
		return false;
	}
	return (urlTimestamp + urlExpires) > (unixTimestamp() + BUFFER);

};
